import React from "react";
import { useTranslation } from "../../../../hooks";
import Button from "./Button";

interface SwapActionsProps {
  onSwap: () => void;
  onReset: () => void;
  isSwapDisabled?: boolean;
}

const SwapActions = ({
  onSwap,
  onReset,
  isSwapDisabled = false,
}: SwapActionsProps) => {
  const { t } = useTranslation("createSwapRequest");

  const handleSwap = () => {
    if (isDisabled) {
      return;
    }

    onSwap();
  };

  const isDisabled = isSwapDisabled;

  return (
    <div className="btn-row">
      <div className="btn">
        <Button
          onClick={handleSwap}
          backgroundColor={isDisabled ? "#CCCCCC" : undefined}
        >
          {t("swap")}
        </Button>
      </div>
      <div className="btn">
        <Button onClick={onReset} backgroundColor="#9D9D9D">
          {t("reset")}
        </Button>
      </div>
    </div>
  );
};

export default SwapActions;
